import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const MessageRoot = superstyled({
  name: 'Message',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['variant'],
  styles: ({ theme, variant }) => ({
    marginBottom: theme.spacing(1),
    ...(variant === 'card' && {
      backgroundColor: theme.palette.background.grey.light,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.border.main}`
    })
  })
});

export const MessageText = superstyled({
  name: 'MessageText',
  slot: 'Text',
  tag: Text,
  styles: ({ theme }) => ({
    whiteSpace: 'pre-wrap',
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  })
});
